import { tableConstantsFactory } from './tableConstantsFactory';
const documentConstantsFactory = prefix => {
  const documentConstants = tableConstantsFactory(prefix);
  documentConstants.SELECTING_ASSOCIATIONS = 'SELECTING_ASSOCIATIONS';
  documentConstants.RESET = 'RESET';
  documentConstants.RENDER = 'RENDER';
  documentConstants.DOWNLOAD_CLEAR = 'DOWNLOAD_CLEAR';
  documentConstants.DOWNLOAD_SUCCESS = 'DOWNLOAD_SUCCESS';
  documentConstants.DOWNLOAD_FAILURE = 'DOWNLOAD_FAILURE';
  documentConstants.RENDER_SUCCESS = 'RENDER_SUCCESS';
  documentConstants.RENDER_FAILURE = 'RENDER_FAILURE';
  documentConstants.CLEAR_DOWNLOAD_PATH = 'CLEAR_DOWNLOAD_PATH';
  return documentConstants;
};
export default documentConstantsFactory;